export default "__VITE_ASSET__RzWHwVpU__"